<template>
    <div class="web-foot">
        <div class="container">
            <div class="info" v-if="infoList.length">
                <span> 今日访问量{{infoList[0].num}} </span>
                <span>本周访问量{{infoList[1].num}}</span>
                <span> 本月访问量{{infoList[2].num}}</span>
                <span> 总访问量{{infoList[3].num}} </span>
            </div>
             <div class="content" v-html="footHtml">
                    </div>

        </div>
    </div>
</template>

<script>
    import {
        webInfo
    } from '@/api/base'
    export default {
        data() {
            return {
                infoList: [],
                footHtml: '',
            }
        },
        created() {
            webInfo().then(result => {
                this.infoList = result.dt;

            })
            this.getList({
                typeId: 'port40',
                rowNum: '1',
                contextFlg: '2'
            }).then(result => {
                this.footHtml = result[0] ? result[0].context : ''
            })
        }
    }
</script>

<style lang="scss">
    .web-foot {
        padding: 20px 0;
        text-align: center;

        .info {
            span {
                margin-right: 10px;
                font-family: 宋体;
                color: white;
                font-size: 12px;
            }

            margin-bottom: 8px;
        }

        .content {
            font-size: 12px;
            font-family: 宋体;
            color: white;
            line-height: 1.6;

        }
    }
</style>